/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordishpriceinvalid4Inputs */

const en_menueditordishpriceinvalid4 = /** @type {(inputs: Menueditordishpriceinvalid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a price like 8.50, at most €1,000`)
};

const de_menueditordishpriceinvalid4 = /** @type {(inputs: Menueditordishpriceinvalid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis wie 8,50 eingeben, höchstens 1.000 €`)
};

/**
* | output |
* | --- |
* | "Enter a price like 8.50, at most €1,000" |
*
* @param {Menueditordishpriceinvalid4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordishpriceinvalid4 = /** @type {((inputs?: Menueditordishpriceinvalid4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordishpriceinvalid4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordishpriceinvalid4(inputs)
	return de_menueditordishpriceinvalid4(inputs)
});
export { menueditordishpriceinvalid4 as "menuEditorDishPriceInvalid" }